export default "__VITE_ASSET__BuIRh1GP__"